export default __webpack_public_path__ + "static/media/insta.a509e0f3.svg";